// CR lcp 21oct26: swiper.js ya no se descarga al cargar la pagina. Se importa e inicializa
// solo cuando el carrusel esta a ~300px del viewport (IntersectionObserver). Los carruseles
// visibles al cargar se inicializan de inmediato (IO dispara al observar). Fallback: sin IO
// o en el editor de temas -> carga inmediata como antes.
(async () => {
    const { Core } = await importModule('Core');
    let Swiper = null;
    let swiperPromise = null;
    const loadSwiper = () => {
        if (!swiperPromise) {
            swiperPromise = importModule('Swiper').then((mod) => { Swiper = mod.Swiper; return Swiper; });
        }
        return swiperPromise;
    };
    const eager = !('IntersectionObserver' in window) || (window.Shopify && Shopify.designMode);
    if (eager) loadSwiper();

    customElements.define('slideshow-inline', class extends Core {
        defaultProps = {
            gap: window.gutterWidth,
            slidesPerView: 4
        }

        elements = {
            swiper: '[data-swiper]',
            pagination: '[data-pagination]',
            buttonPrev: '[data-button-prev]',
            buttonNext: '[data-button-next]'
        }

        render() {
            if (Swiper) {
                this._renderNow();
                return;
            }
            if (eager) {
                loadSwiper().then(() => this.isConnected && this._renderNow());
                return;
            }
            if (this._lazyObserver) return;
            this._lazyObserver = new IntersectionObserver((entries) => {
                if (!entries.some((e) => e.isIntersecting)) return;
                this._lazyObserver.disconnect();
                this._lazyObserver = null;
                loadSwiper().then(() => this.isConnected && this._renderNow());
            }, { rootMargin: '300px 0px' });
            this._lazyObserver.observe(this);
        }

        _renderNow() {
            this._setSwiperProps();
            this._initSwiper();
            this._setSwiperPadding();
            this._setSwiperButtonsPosition();
        }

        disconnect() {
            if (this._lazyObserver) {
                this._lazyObserver.disconnect();
                this._lazyObserver = null;
            }
        }
        
        _initSwiper() {
            this.swiper = new Swiper(this.$swiper, this.swiperProps);
        }

        _setSwiperProps() {
            this.swiperProps = {
                loop: this.withLoop,
                watchSlidesProgress: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                breakpoints: {
                    1: {
                        slidesPerView: 1.5,
                        spaceBetween: this.gap
                    },
                    992: {
                        slidesPerView: this.slidesPerView,
                        spaceBetween: this.gap
                    }
                }
            };
            if(this.withOffset) {
                this.swiperProps.slidesOffsetBefore = this.offset;
                this.swiperProps.slidesOffsetAfter = this.offset;
            }
            if(this.$pagination) {
                this.swiperProps.pagination = {
                    el: this.$pagination,
                    type: 'bullets',
                    clickable: true
                }
                if(this.withOffset) {
                    this.$pagination.style.setProperty('--offset', `${this.offset}px`);
                } else {
                    this.swiperPadding && this.$pagination.style.setProperty('--offset', `${this.swiperPadding}px`);
                }
            }
        }
        
        _setSwiperButtonsPosition() {
            this.swiperPadding && this.$swiper.style.setProperty('--button-position', (this.swiperPadding - this.navButtonWidth / 2) + 'px');
        }

        _setSwiperPadding() {
            if (this.swiperPadding) {
                this.$swiper.style.paddingLeft = this.swiperPadding + 'px';
                this.$swiper.style.paddingRight = this.swiperPadding + 'px';
            }
            return;
        }

        get slidesPerView() {
            return this.getAttribute('slides-per-view') 
                && +this.getAttribute('slides-per-view') 
                || this.defaultProps.slidesPerView;
        }
        get slidesCount() {
            return this.getAttribute('slides-count');
        }
        get gap() {
            return this.getAttribute('gap') 
                && +this.getAttribute('gap') 
                || this.defaultProps.gap;
        }
        get withOffset() {
            return this.hasAttribute('offset');
        }
        get withLoop() {
            return this.hasAttribute('loop') && this.slidesCount > this.slidesPerView;
        }
        get slidesCount() {
            return Number(this.getAttribute('slides-count') || this.querySelectorAll('.swiper-slide').length);
        }
        get offset() {
            return (document.documentElement.offsetWidth - window.containerInnerWidth) / 2;
        }

        get swiperPadding() {
            return this.hasAttribute('container') && (document.documentElement.offsetWidth - window.containerInnerWidth) / 2;
        }

        get navButtonWidth() {
            return this.$buttonNext.offsetWidth;
        }
    })
})();